const data = require(`./data_${process.env.REACT_APP_BUILD_UID}/languages.json`)
const languages = [...data]

export default languages